module.exports = __webpack_public_path__ + "img/step3.ece9bab4.png";